import React from 'react'

import Parallax from "@/Plugins/Parallax";
import RweMiddle from "@/Components/Front/SVGS/RWE/RWE_middle";
import RweTop from "@/Components/Front/SVGS/RWE/RWE_top";
import RweBack from "@/Components/Front/SVGS/RWE/RWE_back";
import RweFar from "@/Components/Front/SVGS/RWE/RWE_far";
import RweInfos from "@/Components/Front/SVGS/RWE/RWE_infos";
import RweEllipsis from "@/Components/Front/SVGS/RWE/RWE_ellipsis";
import RWE_bg from "@/Components/Front/SVGS/RWE/RWE_bg";
import Text from "@/Components/Front/Text";
import Bar from "@/Components/Front/SVGS/Bar";


const ParallaxBA = ({textProps}) => {


    return (

        <div className={"parallax_ba_item"}>

            <div className={"info-parallax-item"}>
                <div className="bar-container">

                    <Bar/>
                </div>
                <h1>
                    <Text {...textProps} str={"rwe-health-ecosystem"}/>
                </h1>
            </div>
            <Parallax hoverOnly>
                <RWE_bg data-depth={.7}/>
                <RweEllipsis data-depth={.3}/>
                <RweInfos lang={textProps.lang} data-depth={.3}/>
                <RweFar data-depth={.4}/>
                <RweBack data-depth={.3}/>
                <RweMiddle data-depth={0.2}/>
                <RweTop lang={textProps.lang}  data-depth={.1}/>

                {/*<img src="https://p.kindpng.com/picc/s/119-1198500_transparent-red-moon-clipart-blood-moon-transparent-background.png" data-depth="0.5"/>*/}
            </Parallax>
        </div>
    )
}


export default ParallaxBA
